// Status badge styles shared between the canvas header and the list view.

export const STATUS_STYLES: Record<string, { label: string; className: string }> = {
  draft:       { label: 'Draft',       className: 'bg-[var(--color-warm-200)] text-[var(--color-text-muted)]' },
  in_progress: { label: 'In progress', className: 'bg-amber-50 text-amber-700' },
  complete:    { label: 'Complete',    className: 'bg-[var(--color-market)]/10 text-[var(--color-market)]' },
}
